import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { BaseButtonComponent } from '@d-components';
import { BaseTextareaComponent } from '@d-components/textarea/textarea.component';

import { ModalService } from '@d-services';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BaseTextareaComponent,
    BaseButtonComponent,
    TranslateModule,
  ],
})
export class DeletePopupComponent {
  fieldControl = new FormControl('', [Validators.required]);
  @Input() confirmMessage: string = 'ARE_YOU_SURE_WANT_TO_DELETE';
  @Input() itemName: string = '';
  @Input() showReason = true;
  @Input() hideLengthCount = true;
  constructor(private modalService: ModalService) {}

  closeDialog(type?: string) {
    if (type === 'submit' && this.showReason && this.fieldControl.invalid)
      return;
    const res = { actionType: type } as any;

    if (this.fieldControl.value) res.reason = this.fieldControl.value ?? '';
    this.modalService.closeModal(res);
  }
}
